<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("metaInsights.channelDetails") }}</div>
            <div class="subtitle">{{ $t("metaInsights.manageChannel") }}</div>
        </div>

        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("message.channelName") }}</label>
                    <a-input
                        :placeholder="$t('message.channelName')"
                        v-model="clone.name"
                        v-validate="'required'"
                        name="channelName"
                    />
                </div>

                <div class="input-wrapper" v-if="adAccount">
                    <label>{{ $t("metaInsights.connectedAdAccount") }}</label>
                    <div class="ad-account-info">
                        <div class="row">
                            <span class="muted">{{ $t("metaInsights.adAccountName") }}:</span>
                            <strong>{{ adAccount.name }}</strong>
                        </div>
                        <div class="row">
                            <span class="muted">ID:</span>
                            <code>{{ adAccount.id }}</code>
                        </div>
                        <div class="row" v-if="adAccount.business && adAccount.business.name">
                            <span class="muted">{{ $t("metaInsights.business") }}:</span>
                            <strong>{{ adAccount.business.name }}</strong>
                        </div>
                        <div class="row" v-if="adAccount.currency">
                            <span class="muted">{{ $t("metaInsights.currency") }}:</span>
                            <strong>{{ adAccount.currency }}</strong>
                        </div>
                        <div class="row" v-if="adAccount.timezone_name">
                            <span class="muted">{{ $t("metaInsights.timezone") }}:</span>
                            <strong>{{ adAccount.timezone_name }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import { mapActions, mapState } from "vuex";

export default Vue.extend({
    name: "UpdateDetail",
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
        adAccount() {
            return _.get(this.clone, "payload.selectedAdAccount");
        },
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
        }),
        handleSave() {
            const payload = this.clone;
            this.loading = true;
            this.updateChannel(payload)
                .then(() => {
                    this.listChannels();
                    this.$message.success(this.$t("message.channelUpdatedSucs"));
                    this.$emit("input", this.clone);
                    this.clone = _.cloneDeep(this.clone);
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(this.$t("message.failedUpdateChannel"));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }

    .form-wrapper {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .input-wrapper {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .ad-account-info {
        background: var(--color-bg-subtle, #fafafa);
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        padding: 12px;
        display: flex;
        flex-direction: column;
        gap: 6px;

        .row {
            display: flex;
            gap: 8px;

            .muted {
                color: var(--color-text-muted-default);
                min-width: 110px;
            }

            code {
                background: var(--color-bg-default);
                padding: 1px 6px;
                border-radius: 4px;
            }
        }
    }
}
</style>
